<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">웹 선불권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountuse" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">웹 선불권 적용</p>
          <ul class="depth">
            <li><router-link to="/webdiscountcharge" title="웹 선불권 충전">웹 선불권 충전</router-link></li>
            <li><router-link to="/webdiscountuse" title="웹 선불권 적용">웹 선불권 적용</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle web">웹 선불권 적용</h3>
        <article class="selectOpt type02">
          <dl>
            <dt>
              <h4 class="tit">차량번호 조회</h4>
              <p class="subTxt">선불권을 적용 할 차량번호를 입력하세요.</p>
            </dt>
            <dd>
              <input
                type="text"
                title="차량번호 입력"
                placeholder="차량번호 뒤 4자리 입력(예:4567)"
                :value="selectCarNo"
                @input="bindNumber"
                maxlength="4"
                @keyup.enter="clickApplyBtn()"
              />
              <button type="button" class="btn dkGray" @click="clickApplyBtn()">조회</button>
            </dd>
          </dl>
        </article>
        <article>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <LoadingSpinner v-if="isLoading"></LoadingSpinner>
              <table v-else>
                <caption>
                  웹 선불권 적용 테이블
                </caption>
                <thead>
                <tr>
                  <th scope="col">차량번호</th>
                  <th scope="col">주차장</th>
                  <th scope="col">입차시간</th>
                  <th scope="col">현재 주차장 이용시간</th>
                  <th scope="col">주차 할인</th>
                </tr>
                </thead>
                <tbody>
                <tr class="nodate" v-if="nodata">
                  <td colspan="5">조회된 데이터가 없습니다.</td>
                </tr>
                <tr v-for="(carInfo, index) in carList" :key="index">
                  <td>{{ carInfo.carNo }}</td>
                  <td>{{ carInfo.parkingNm }}</td>
                  <td>{{ carInfo.inDttm }}</td>
                  <td>{{ carInfo.useTm | comma }} 분</td>
                  <td>
                    <button type="button" class="btn gray" @click="carInfoView(carInfo)">선택</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="info">적용한 시간은 취소 및 환불되지 않으니 반드시 차량번호를 확인해 주세요.</p>
<!--          <p class="info">입차 후 30분 기본 무료 적용됩니다.</p>-->
<!--          <p class="info">기본 할인 – 2시간 내에서 최소 30분 단위로 손님 차량의 주차요금에 대한 기본 할인 가능</p>-->
<!--          <p class="info">기본 할인 외 추가 할인 시 업주가 비용 부담(충전한 웹 선불권 시간에서 해당시간 차감)</p>-->
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-match v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg }}</p>
        <article class="btnArea">
          <button class="btn gray" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-match>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';

import AlertMatch from '../../../components/Alert01.vue';

export default {
  data() {
    return {
      selectCarNo: '',
      msg: '',
      isLoading: false,
      showModalMsgSuccess: false,
      nodata: true,
      carList: [],
    };
  },

  components: {
    LoadingSpinner,
    AlertMatch,
  },

  mounted() {},

  methods: {
    CancleBtn() {
      this.showModalMsgSuccess = false;
    },

    CloseBtn() {
      this.showModalMsgSuccess = false;
    },
    bindNumber(event) {
      this.selectCarNo = event.target.value;
    },

    async clickApplyBtn() {
      if (this.selectCarNo.length < 4) {
        this.msg = '4자리 전부 입력해주세요.';
        this.showModalMsgSuccess = true;
      } else {
        this.isLoading = true;
        const res = await axios('get', '/api/time/list.json', {
          carNo: this.selectCarNo,
        });
        this.isLoading = false;

        const data = res.data?.result?.list;

        if (data.length === 0) {
          this.carList = [];
          this.nodata = true;
          return;
        }
        this.carList = data;
        if (this.carList.length > 0) {
          this.nodata = false;
        } else if (this.carList.length === 0) {
          this.nodata = true;
        }
      }
    },

    carInfoView(carInfo) {
      // const params = {
      //   inOutId: carInfo.inOutId,
      //   sectnId: carInfo.sectnId,
      //   carNo: carInfo.carNo,
      //   inDttm: carInfo.inDttm,
      //   freeTm: carInfo.freeTm,
      //   useTm: carInfo.useTm,
      // };
      // this.$router.push({
      //   name: 'webdiscountuseview',
      //   params: { data: params },
      // });
      this.$router.push({
        name: 'webdiscountuseview',
        params: {
          carNo: carInfo.carNo,
          useTm: carInfo.useTm,
          freeTm: carInfo.freeTm,
          inOutId: carInfo.inOutId,
          inDttm: carInfo.inDttm,
        },
      });
    },
  },
  watch: {
    selectCarNo(val) {
      const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/;

      // 한글, 영문 체크
      if (reg.exec(val) !== null) this.selectCarNo = val.replace(/[^0-9]/g, '');

      // .... 만 입력하게 될 경우 체크
      if (isNaN(parseFloat(val))) this.selectCarNo = '';
    },
  },
};
</script>
